import { useReactFlow } from '@xyflow/react';
import { Maximize, Minus, Plus } from 'lucide-react';

const CustomControls = () => {
  const { zoomIn, zoomOut, fitView } = useReactFlow();

  return (
    <div className='absolute bottom-4 left-4 z-50 flex flex-col gap-2'>
      <button
        onClick={zoomIn}
        className='flex h-8 w-8 items-center justify-center rounded-md border border-border bg-background p-2 text-foreground shadow-md hover:bg-accent'
        aria-label='Zoom In'
      >
        <Plus className='h-4 w-4' />
      </button>
      <button
        onClick={zoomOut}
        className='flex h-8 w-8 items-center justify-center rounded-md border border-border bg-background p-2 text-foreground shadow-md hover:bg-accent'
        aria-label='Zoom Out'
      >
        <Minus className='h-4 w-4' />
      </button>
      <button
        onClick={fitView}
        className='flex h-8 w-8 items-center justify-center rounded-md border border-border bg-background p-2 text-foreground shadow-md hover:bg-accent'
        aria-label='Fit View'
      >
        <Maximize className='h-4 w-4' />
      </button>
    </div>
  );
};

export default CustomControls;
